module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-600italic.02c48333.woff";